/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IEdmModel } from '../../models/i-edm-model';

export interface OdataMetadata$JsonOdataMetadataFullOdataStreamingFalse$Params {
}

export function odataMetadata$JsonOdataMetadataFullOdataStreamingFalse(http: HttpClient, rootUrl: string, params?: OdataMetadata$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<IEdmModel>> {
  const rb = new RequestBuilder(rootUrl, odataMetadata$JsonOdataMetadataFullOdataStreamingFalse.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=full;odata.streaming=false', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IEdmModel>;
    })
  );
}

odataMetadata$JsonOdataMetadataFullOdataStreamingFalse.PATH = '/odata/$metadata';
